<template>
  <div class="xjydsq">
    <Header title="学籍异动申请" type="0" route="/homeIndex"></Header>
    <div class="xsxxxgsq_main">
      <!-- <div class="xsxxxgsq_main_header">
        <div class="header_title" @click="showPop('学年学期', 'xnxq')">
          <span>{{ info.xxxx ? info.xxxx : "-" }}</span>
          <van-icon name="play" />
        </div>
        <div class="header_time">
          <span>起止时间:</span>
          <p>
            {{ info.xxxx ? info.xxxx : "-" }} ~
            {{ info.xxxx ? info.xxxx : "-" }}
          </p>
        </div>
      </div> --> 

      <van-tabs
        ref="vanTabs"
        type="card"
        v-model="active"
        @change="getList"
        sticky
        offset-top="50px"
      >
        <van-tab title="全部">
          <NOdata
            title="暂无学籍异动申请数据~"
            v-if="this.arrList.length == 0"
          ></NOdata>
          <mode-list
            v-else
            v-for="(item, index) in arrList"
            :key="index"
            :item="item"
            @detail="detail"
          ></mode-list>
        </van-tab>
        <van-tab title="未通过">
          <NOdata
            title="暂无学籍异动申请数据~"
            v-if="this.arrList.length == 0"
          ></NOdata>
          <mode-list
            v-else
            v-for="(item, index) in arrList"
            :key="index"
            :item="item"
            @detail="detail"
          ></mode-list>
        </van-tab>
        <van-tab title="审核中">
          <NOdata
            title="暂无学籍异动申请数据~"
            v-if="this.arrList.length == 0"
          ></NOdata>
          <mode-list
            v-else
            v-for="(item, index) in arrList"
            :key="index"
            :item="item"
            @detail="detail"
          ></mode-list>
        </van-tab>
        <van-tab title="通过">
          <NOdata
            title="暂无学籍异动申请数据~"
            v-if="this.arrList.length == 0"
          ></NOdata>
          <mode-list
            v-else
            v-for="(item, index) in arrList"
            :key="index"
            :item="item"
            @detail="detail"
          ></mode-list>
        </van-tab>
      </van-tabs>
      <div class="xsxxxgsq_main_button" @click="apply">
        <van-icon name="plus" />
        <span>申请异动</span>
      </div>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="textList.title"
        show-toolbar
        :columns="textList.columns"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, textList.field);
          }
        "
      />
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
import modeList from "./mode/modeList.vue";
export default {
  components: { modeList },
  data() {
    return {
      xnxq: {},
      active: 0,
      info: {},
      arrList: [],
      show: false,
      textList: {
        title: "",
        field: "",
        columns: []
      },
      columns: {}
    };
  },
  created() {
    this.active = Number(this.$route.query.active);
    this.getList(0, "全部");
  },
  methods: {
    detail(item) {
      this.$router.push({
        path: "/xjydsq/detail",
        query: {
          type: "detail",
          active: this.active,
          xs0702id: item.xs0702id,
          iswfmes: item.iswfmes,
        }
      });
    },
    apply() {
      this.$router.push({
        path: "/xjydsq/detail",
        query: {
          type: "apply",
          active: this.active
        }
      });
    },
    // 弹出选择器
    showPop(title, field) {
      this.show = true;
      this.textList.title = title;
      this.textList.field = field;
      this.textList.columns = this.columns[field];
    },
    // 选择确认
    onConfirm(value, index, field) {
      this.show = false;
      this[field].text = value[0].text;
      this[field].value = value[0].value;
      this.getList();
    },
    async getList(name, title) {
      this.arrList = [];
      const res = await Api.findXjydList();
      if (res.code == "1") {
        switch (title) {
          case "全部":
            this.arrList = res.data;
            break;
          case "未通过":
            this.arrList = res.data.filter(item => item.iswfmes == 0);
            break;
          case "审核中":
            this.arrList = res.data.filter(item => item.iswfmes == 2);
            break;
          case "通过":
            this.arrList = res.data.filter(item => item.iswfmes == 1);
            break;
          default:
            break;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.xjydsq {
  height: 100%;
  background-color: #f2f2f4;
  box-sizing: border-box;
  overflow: auto;
  .xsxxxgsq_main {
    display: flex;
    flex-direction: column;
    height: 100%;
    // padding: 12px 15px;
    padding: 0 15px 12px;
    box-sizing: border-box;
    .xsxxxgsq_main_header {
      background-color: #887eff;
      border-radius: 8px;
      padding: 18px 15px 23px;
      box-sizing: border-box;
      span {
        white-space: nowrap;
      }
      .header_title {
        display: flex;
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #ffffff;
        letter-spacing: 0;
        font-weight: 600;
        line-height: 25px;
        margin-bottom: 9px;
        .van-icon {
          transform: rotate(90deg);
          font-size: 14px;
        }
      }
      .header_time {
        display: flex;
        line-height: 13px;
        font-family: SourceHanSansCN-Regular;
        font-size: 13px;
        color: #ffffff;
        letter-spacing: 0;
        font-weight: 400;
        p {
          white-space: wrap;
          margin-left: 5px;
        }
      }
    }
    .van-tabs {
      flex: 1;
    }
    .xsxxxgsq_main_button {
      position: fixed;
      left: 50%;
      bottom: 60px;
      transform: translate(-50%, 0);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 215px;
      height: 44px;
      background-color: #7469f8;
      box-shadow: 0px 4px 8px 0px rgba(116, 105, 248, 0.2);
      border-radius: 25px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      line-height: 16px;
      color: #ffffff;
      font-weight: bolder;
      .van-icon {
        margin-right: 8px;
        font-size: 14px;
        border: 1.5px solid #fff;
        border-radius: 2px;
      }
    }
  }
  /deep/.van-sticky--fixed {
    padding: 0 15px;
  }
  /deep/.van-tabs__wrap {
    .van-tabs__nav--card {
      margin: 0;
      border: none;
      background-color: #f2f2f4;
      padding: 12px 0;
      height: 54px;

      .van-tab {
        border-right: unset;
        font-family: SourceHanSansCN-Regular;
        font-size: 14px;
        color: #8d8d8d;
        letter-spacing: 0;
        font-weight: 400;
        flex: unset;
        padding: 0 13px;
      }
      .van-tab.van-tab--active {
        background: rgba(116, 105, 248, 0.15);
        border-radius: 16px;
        color: #7469f8;
      }
    }
  }
  /deep/.van-tabs__content {
    height: calc(~"100% - 42px");
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/xjydsq/index.vue